import { NextLiveCall } from './next-live-call';
import { LibrarySidebar } from './library-sidebar';
import { AIP_COURSE_ID } from 'shared/mirasee-consts';
import type { CommunityMeetings, CommunityModules, CommunityRsvpAvatars } from './types';

export function RightSidebar({
  meetings,
  rsvpAvatars,
  modules,
}: {
  meetings: CommunityMeetings;
  rsvpAvatars: CommunityRsvpAvatars;
  modules: CommunityModules;
}) {
  return (
    <div class="w-full lg:w-72 xl:w-80 lg:shrink-0">
      <NextLiveCall meetings={meetings} rsvpAvatars={rsvpAvatars} />

      <a
        href={`/courses/${AIP_COURSE_ID}/calendar`}
        class="inline-flex items-center gap-2 px-2 py-2 mb-4 text-sm font-medium text-indigo-600 hover:text-indigo-700 no-underline transition"
      >
        <svg
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          style="width: 16px; height: 16px; flex-shrink: 0"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
          />
        </svg>
        View full calendar
        <svg
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.5"
          stroke="currentColor"
          style="width: 14px; height: 14px; flex-shrink: 0"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </a>

      <LibrarySidebar modules={modules} />
    </div>
  );
}
